import * as React from 'react';
import Button from '@mui/material/Button';
import { FormDialog } from './FormDialog';
import Box from '@mui/material/Box';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import { TicketsHistory } from './TicketHistory';
import { useTitle } from "../../context/TitleProvider";

export const Ticket = () => {
    const {setTitle} = useTitle()
    const [issue, setIssue] = React.useState('');
    const [issueMessage, setIssueMessage] = React.useState('');

    const handleChange = (event) => {
      setIssue(event.target.value);
    };
    setTitle("Support")
    const [open, setOpen] = React.useState(false);

    const handleClickOpen = () => {
      setOpen(true);
    };
     return  <div style={{alignItems: 'center', justifyContent: 'center', textAlign: 'center'}}> 
        <br/>
         <Box sx={{ minWidth: 120 }}>
         <h1>Having an issue?</h1>
         <h1>Don't worry, we will reach you in minimum time possible!</h1>
         <Box sx={{ minWidth: 120 }}>
      <FormControl fullWidth>
        <InputLabel id="select-label">Dispute</InputLabel>
        <Select
          labelId="select-label"
          id="select"
          value={issue}
          label="Issue"
          onChange={handleChange}
          sx={{textAlign: 'center'}}
        >
          <MenuItem value={"Order Dispute"}>Order Dispute</MenuItem>
          <MenuItem value={"Tech Dispute"}>Tech Dispute</MenuItem>
          <MenuItem value={"Gift Dispute"}>Gift Dispute</MenuItem>
          <MenuItem value={"Login Dispute"}>Login Dispute</MenuItem>
          <MenuItem value={"Portfolio Dispute"}>Portfolio Dispute</MenuItem>
          <MenuItem value={"Customer Service Dispute"}>Customer service Dispute</MenuItem>
          <MenuItem value={"Other"}>Other</MenuItem>
        </Select>
      </FormControl>
    </Box>
    <br/>
      <Button disabled={issue.length===0} variant="outlined" onClick={handleClickOpen}>
        Type your query
   </Button>
     <FormDialog issueMessage={issueMessage} setIssueMessage={setIssueMessage} issue={issue} open={open} setOpen={setOpen}/>
     </Box>
     <br/>
     <TicketsHistory/>
   </div>


}




